import React from 'react';
import ReactDOM from 'react-dom';
import loadable from '@loadable/component';
import eventemitter3 from 'eventemitter3';

import { create } from './App/local-dev';
import { IObjectString } from './App/interfaces/IObjectStructure';
import { getAllUrlParams } from './App/utils/getAllUrlParams/getAllUrlParams';
import { BreakpointsProvider } from './App/hooks/breakpoints/BreakpointsContext';
import { ModuleVersion } from "@phantom/ph-client-common/utils/ModuleVersion";
import { DispatcherStorage } from "@phantom/ph-client-common/events/injectDispatcher";

new ModuleVersion().log();

const App = loadable(() => import('./App/App'));

const dispatcher = new eventemitter3();
DispatcherStorage.init(dispatcher as any);

const urlParams: IObjectString = getAllUrlParams(window.location.href);
if (urlParams.testMode) {
    create(dispatcher);
}

ReactDOM.render(
    <BreakpointsProvider>
        <App dispatcher={dispatcher} urlParams={urlParams} />
    </BreakpointsProvider>,
    document.getElementById('root'),
);
